// extracted by mini-css-extract-plugin
module.exports = {"Input":"ImportGameForm_Input__2mNEk","DisableForm":"ImportGameForm_DisableForm__2iHLg"};